<template>
  <div>
    <ul
      role="tablist"
      class="step-nav-pills"
    >
      <li
        v-for="(step, key) in steps"
        step-size="md"
      >
        <a
          class="link-item"
          :class="$route.name === step.name ? 'active' : ''"
          @click="handleRouteChange(step.name)"
        >
          <span
            class="step-title"
          >
            {{ step.title }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      steps: [
        {
          name: 'home',
          title: '01 YOUR URL',
        },
        {
          name: 'keywords',
          title: '02 YOUR KEYWORDS'
        },
        {
          name: 'results',
          title: '03 VIEW COMPETITORS'
        },
      ]
    }
  },

  computed: {
    ...mapState('app', ['url']),

    ...mapState('keyword', ['keywords'])
  },

  methods: {
    handleRouteChange(step) {
      const keywords = Object.keys(this.keywords);

      switch (step) {
        case 'results':
          if(keywords.length > 0) {
            this.$router.push({ name: 'results', query: { keywords: Object.keys(this.keywords) }})
          }
          break;
        case 'keywords':
          if (this.url) {
            this.$router.push({ name: 'keywords' })
          }
          break;
        default:
          window.location = '/';
          break;
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  .step-nav-pills {
    position: relative;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    list-style: none;

    li {
      flex: 1;
      align-items: center;
      flex-wrap: wrap;
      flex-grow: 1;
      
      .step-title {
        font-family: Montserrat, sans-serif;
        font-size: 13px;
        font-weight: 700;
        border-bottom: 5px solid transparent;
        background: -webkit-gradient(linear, right top, left top, from(#e6e6e6), to(#e6e6e6)) left bottom no-repeat;
        background: linear-gradient(270deg, #e6e6e6 0%, #e6e6e6 100%) left bottom no-repeat;
        background-size: 100% 5px;
        max-width: 18rem;
        width: 100%;
        padding-bottom: 1.5rem;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #cdcdcd;
        transition: all .3s ease-in-out;
        &:hover {
          opacity: .7;
        }
      }
      .link-item {
        cursor: pointer;

        &.active {
          .step-title {
            color: #000000 !important;
            text-transform: uppercase;
            background: -webkit-gradient(linear, right top, left top, from(#3caef3), to(#266ce7)) left bottom no-repeat;
            background: linear-gradient(270deg, #3caef3 0%, #266ce7 100%) left bottom no-repeat;
            background-size: 100% 5px;
            &:hover {
              opacity: 1;
            }
          }
        }
      }
    }
  }
</style>
